import { render, staticRenderFns } from "./groupsManageList.vue?vue&type=template&id=7951ba89&"
import script from "./groupsManageList.vue?vue&type=script&lang=js&"
export * from "./groupsManageList.vue?vue&type=script&lang=js&"
import style0 from "./groupsManageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports